module.exports = {"version":"1.8.9","platform":"external","rootUrl":"https://api.sunfig.com","apiUrl":"https://api.sunfig.com/1.8","env":"prod"};